"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldUseClowder = void 0;
const taskStore_1 = require("../../../taskStore");
const clowderSetup_1 = require("./clowderSetup");
const shouldUseClowder = () => {
    const { task, scoringVersion, isRoarApp } = (0, taskStore_1.taskStore)();
    const taskConfig = clowderSetup_1.CLOWDER_CONFIG[task];
    // Use Clowder if ROAR app and task supports Clowder
    // Normed tasks without scoringVersion will default to original item selection and scoring
    return Boolean(isRoarApp && (taskConfig === null || taskConfig === void 0 ? void 0 : taskConfig[scoringVersion]));
};
exports.shouldUseClowder = shouldUseClowder;
